import React from "react";
import { Redirect, RouteComponentProps } from "react-router";

type OwnProps = {};
type Props = OwnProps & RouteComponentProps;

const PRIVACY_POLICY_URL =
  "https://firebasestorage.googleapis.com/v0/b/sweet-space.appspot.com/o/legal%2FSweet%20Privacy%20Policy.pdf?alt=media&token=1a6e5ef4-83b2-4935-bc6d-3600abbb3157";

const Privacy: React.FC<Props> = props => {
  window.location.href = PRIVACY_POLICY_URL;

  return null;
};

export default Privacy;
